import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selected: 'home',
    scrollTop: 0 // 屏幕滚动距离
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
